import React from "react";

import { IconTag } from "./IconTag";

type PlainTagProps = {
  text: string;
};

/**
 * An IconTag wrapper to display a time in a tag (rendered by default as a
 * locale string).
 * @param {string|Date} time Time being dislpayed.
 */
export function PlainTag({ text, ...delegated }: PlainTagProps) {
  return <IconTag text={text} {...delegated} />;
}
